<div class="wrap">
  <div class="header" id="header_home">
    <div class="header_title">

      <ul class="nav">
        <li *ngFor="let m of mainMenu" class="nav_item" (click)="getRouteNavigate(m.url)"
          [ngClass]="{active: ifRouteActive(m?.url)}">{{m.name}} <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="m.url === '/home'">
          </fa-icon>
        </li>
      </ul>

      <h1 *ngIf="titleHomePage !== 'Trouver une activité'">{{titleHomePage}}</h1>
      <div class="search_activity" *ngIf="titleHomePage === 'Trouver une activité'" (click)="openSearchDiv()" >
        <span>Trouver une activité</span>
        <fa-icon [icon]="getFaIcon('faSearch')" appChangeColorTheme attribute="bgc" ></fa-icon>
      </div>
     
    </div>
    <div class="shadow"></div>
  </div>
</div>
